<button kendoButton size="large" class="button" (click)="this.open()">{{'Analoog' | translate: 'Analoog'}}</button>
<kendo-dialog *ngIf="isEditing" title="{{'Analoog' | translate: 'Analoog'}}" width="550px" [height]="'auto'" [maxHeight]="'95%'" (close)="this.close()">    
        @for (ai of propsService.ais(); track ai.index) {
            <aieditor [initialValue]="ai" [class.led-even]="$even" [class.led-odd]="$odd" class="mouse-over" />
        }
        <div class="splitter"></div>
        @for (ai of this.availableAIs(); track ai.index) {
            <aieditor [initialValue]="ai" [class.led-even]="$even" [class.led-odd]="$odd" class="mouse-over"  [onlyDesc]="true"/>
        }
</kendo-dialog>